import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import styles from './Label.module.scss';
const Label = ({ type = 1, text, className }) => {
    return (_jsx("span", Object.assign({ className: cn(text !== '' && styles.element, className, styles[`hasType-${type}`]) }, { children: text })));
};
export default Label;
